import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const findUserDrafts = async () => {
    try {
        const accessToken = await retrieveAccessToken();
        const response = await axios.get(`/api/editor/drafts`, {
            headers: {
                ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
            }
        });
        if (!response.data) {
            throw new Error("No data received");
        }
        return response.data;
    } catch (error) {
        throw new Error(
            error.response
                ? `Error fetching draft: ${error.response.status} ${error.response.statusText}`
                : error.message
        );
    }
};

export { findUserDrafts };